const pricingPlansEN = [
  {
    name: 'Professional',
    description: 'For growing sales teams',
    monthlyPrice: '$50',
    annualPrice: '$480',
    monthlyPeriod: 'per account/month',
    annualPeriod: 'per account/annual',
    annualOffer: 'Limited time offer: FREE one SAPOT Note with annual plan',
    features: [
      'Unlimited recordings',
      'Full AI analysis & coaching',
      'Auto follow-up',
      'Survey management',
      'SQL Agent',
      'Priority support',
    ],
    buttonText: 'Get started',
    featured: true,
  },
  {
    name: 'Enterprise',
    description: 'For large organizations',
    monthlyPrice: 'Custom',
    annualPrice: 'Custom',
    monthlyPeriod: 'tailored to your needs',
    annualPeriod: 'tailored to your needs',
    features: [
      'Everything in Professional',
      'Unlimited teams & users',
      'Custom integrations',
      'New feature request',
      'Dedicated account manager',
      'SLA guarantee',
      'On-premise option',
    ],
    buttonText: 'Contact Sales',
    featured: false,
  },
];

const pricingPlansZH = [
  {
    name: '专业级',
    description: '适合成长中的销售团队',
    monthlyPrice: '$50',
    annualPrice: '$480',
    monthlyPeriod: '每账户/月',
    annualPeriod: '每账户/年',
    annualOffer: '限时优惠:订购年付方案,免费赠送一台 SAPOT Note',
    features: [
      '无限次录音',
      '完整的 AI 分析与辅导',
      '自动跟进',
      '问卷管理',
      'SQL Agent',
      '优先客户支持',
    ],
    buttonText: '立即开始',
    featured: true,
  },
  {
    name: '旗舰级',
    description: '适合大型企业组织',
    monthlyPrice: '定制',
    annualPrice: '定制',
    monthlyPeriod: '按需定制',
    annualPeriod: '按需定制',
    features: [
      '包含专业级全部功能',
      '无限团队与用户数',
      '定制化集成',
      '新功能需求',
      '专属客户经理',
      'SLA 服务保障',
      '本地部署选项',
    ],
    buttonText: '联系销售',
    featured: false,
  },
];

export const getPricingPlans = (lang) => (lang === 'zh' ? pricingPlansZH : pricingPlansEN);

const sapotNoteAddonEN = {
  name: 'SAPOT Note',
  description: 'Dedicated audio recorder device',
  price: '$200',
  period: 'per device',
};

const sapotNoteAddonZH = {
  name: 'SAPOT Note',
  description: '专属录音设备',
  price: '$200',
  period: '每台设备',
};

export const getSapotNoteAddon = (lang) => (lang === 'zh' ? sapotNoteAddonZH : sapotNoteAddonEN);

const pricingFaqsEN = [
  {
    question: 'What languages does SAPOT AI support?',
    answer: 'SAPOT AI supports over 70 languages including English, Malay, and Mandarin with Malaysian code-switching. Our speech-to-text models (ElevenLabs Scribe v1 and Groq Whisper v3) are optimized for the Malaysian multilingual environment.',
  },
  {
    question: 'How does the recording work?',
    answer: 'Salespeople can record in-person conversations using the SAPOT Note audio recorder device, their phone, or tablet. Audio can also be imported directly. Recordings are automatically transcribed and analyzed by our AI with KPI scoring, customer profiling, and conversation summaries.',
  },
  {
    question: 'Can I customize the KPI scoring criteria?',
    answer: 'Yes. Company admins can fully configure KPI scoring areas and weights (e.g., greeting 10%, needs discovery 25%, product knowledge 20%, objection handling 25%, closing 20%). You can also define ideal sales flow steps, compliance checklists, red flags, and industry-specific terminology.',
  },
  {
    question: 'What is the SQL Agent feature?',
    answer: 'The SQL Agent lets managers and admins ask business questions in natural language. The AI generates and executes SQL queries on your sales data and returns easy-to-understand answers with auto-summaries. All queries are logged and auditable.',
  },
  {
    question: 'How does the auto follow-up work?',
    answer: 'After a conversation is analyzed, SAPOT AI can automatically generate a WhatsApp follow-up message based on the conversation context. Company admins can configure webhook integrations for automatic dispatch, and managers can monitor all follow-up messages with draft/sent/failed status tracking.',
  },
  {
    question: 'What kind of analytics are available?',
    answer: 'SAPOT AI provides traffic analytics (monthly trends, channel distribution, hourly patterns), team performance comparisons with radar charts, customer intent analysis, lead quality distribution, cost analytics with API usage breakdown, and individual KPI trending over time.',
  },
];

const pricingFaqsZH = [
  {
    question: 'SAPOT AI 支持哪些语言?',
    answer: 'SAPOT AI 支持超过 70 种语言,包括英语、马来语及含马来西亚多语混用的普通话。我们的语音转文字模型(ElevenLabs Scribe v1 和 Groq Whisper v3)已针对马来西亚多语环境进行深度优化。',
  },
  {
    question: '录音功能是如何工作的?',
    answer: '销售人员可以使用 SAPOT Note 录音设备、手机或平板电脑录制线下面谈对话,也可以直接导入音频文件。录音会被自动转写,并由 AI 进行 KPI 评分、客户画像分析和对话摘要生成。',
  },
  {
    question: '我可以自定义 KPI 评分标准吗?',
    answer: '可以。企业管理员可以完全自定义 KPI 评分维度与权重(例如:问候 10%、需求挖掘 25%、产品知识 20%、异议处理 25%、成交 20%)。您还可以定义理想销售流程、合规检查清单、风险提示及行业专属术语。',
  },
  {
    question: 'SQL Agent 功能是什么?',
    answer: 'SQL Agent 让管理者和管理员能以自然语言提出业务问题。AI 会自动生成并执行 SQL 查询,并以易于理解的方式返回结果和自动摘要。所有查询都会被记录并可供审计。',
  },
  {
    question: '自动跟进是如何工作的?',
    answer: '对话分析完成后,SAPOT AI 可以基于对话内容自动生成 WhatsApp 跟进消息。企业管理员可以配置 webhook 集成以实现自动发送,管理者则可以监控所有跟进消息的草稿/已发送/发送失败状态。',
  },
  {
    question: '平台提供哪些数据分析?',
    answer: 'SAPOT AI 提供流量分析(月度趋势、渠道分布、小时段规律)、团队绩效雷达对比、客户意向分析、线索质量分布、含 API 用量明细的成本分析,以及个人 KPI 长期趋势追踪。',
  },
];

export const getPricingFaqs = (lang) => (lang === 'zh' ? pricingFaqsZH : pricingFaqsEN);
